if (!customElements.get('kj-knowledge-index')) {
  customElements.define(
    'kj-knowledge-index',
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.querySelectorAll('.kj-knowledge-index__entries').forEach((list) => {
          let gesture = null;
          let suppressClick = false;

          list.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
          list.addEventListener(
            'pointerdown',
            (event) => {
              if (event.pointerType !== 'mouse' || event.button !== 0) return;
              if (list.scrollHeight <= list.clientHeight) return;
              // Keep the native scrollbar available for dragging as well.
              if (event.clientX > list.getBoundingClientRect().right - 12) return;
              gesture = { id: event.pointerId, y: event.clientY, scroll: list.scrollTop, dragging: false };
              suppressClick = false;
            },
            { signal }
          );
          list.addEventListener(
            'pointermove',
            (event) => {
              if (!gesture || gesture.id !== event.pointerId) return;
              const delta = event.clientY - gesture.y;
              if (!gesture.dragging && Math.abs(delta) < 5) return;
              if (!gesture.dragging) {
                gesture.dragging = true;
                list.setPointerCapture(event.pointerId);
                list.classList.add('is-dragging');
                window.getSelection()?.removeAllRanges();
              }
              event.preventDefault();
              list.scrollTop = gesture.scroll - delta;
            },
            { signal }
          );

          const finish = (event) => {
            if (!gesture || gesture.id !== event.pointerId) return;
            const current = gesture;
            gesture = null;
            suppressClick = current.dragging;
            list.classList.remove('is-dragging');
            if (list.hasPointerCapture(current.id)) list.releasePointerCapture(current.id);
          };
          list.addEventListener('pointerup', finish, { signal });
          list.addEventListener('pointercancel', finish, { signal });
          list.addEventListener('lostpointercapture', finish, { signal });
          list.addEventListener(
            'click',
            (event) => {
              if (!suppressClick) return;
              suppressClick = false;
              event.preventDefault();
              event.stopImmediatePropagation();
            },
            { capture: true, signal }
          );
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    }
  );
}
